import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { addToCart } from "../../../../store/order";
import { graphql, navigate, useStaticQuery } from "gatsby";
import OrderInTheNext from "../../../ecommerce/OrderInTheNext";
import { getPriceToShow } from "../../../../utils/currency";
import ecommerceApi from "../../../../services/ecommerceApi";
import EcommerceApi from "../../../../services/ecommerceApi";
import { getProductImage } from "../../../../utils/image";
import Button from "../../../shared/Button";
export interface ProductBuyButtonProps {
    product: ProductType;
}
import {
    ProductCategoryType,
    ProductDataType,
    ProductTaxCodeType,
    ProductType
} from "../../../../types";
import { useSalesChannel } from "../../../../context/SalesChannelContext";
import Spinner from "../../../shared/Spinner";

export default function ProductBuyButton({ product }: ProductBuyButtonProps) {
    const dispatch = useDispatch<AppDispatch>();

    const salesChannel = useSalesChannel();

    const order = useSelector((state: RootState) => state.order.order);
    const currencyCode = useSelector(
        (state: RootState) => state.currencyCode.selectedCurrencyCode?.currencyCode
    );

    const [quantity, setQuantity] = React.useState(1);
    const [selectedProductData, setSelectedProductData] = React.useState<ProductDataType | null>(
        null
    );
    const [adding, setAdding] = React.useState(false);

    const loadProductData = async () => {
        if (product) {
            const productId = product.product || product.id;
            const [productData, taxCodes] = await Promise.all([
                ecommerceApi.getProductData(productId),
                ecommerceApi.getProductTaxCodesData(productId)
            ]);
            setSelectedProductData(productData || null);
        }
    };

    const handleAddToCartClick = async () => {
        setAdding(true);
        const orderId = order ? order.id : undefined;
        const params = {
            orderId: orderId,
            skuId: product.id,
            quantity: 1,
            salesChannel
        };
        await dispatch(addToCart(params));
        setAdding(false);
    };

    const pricing = useMemo(() => {
        if (selectedProductData) {
            const listPrice = getPriceToShow(
                selectedProductData.listPrice,
                salesChannel,
                currencyCode,
                undefined,
                product || undefined
            );
            return {
                price: getPriceToShow(
                    selectedProductData.currentPrice,
                    salesChannel,
                    currencyCode,
                    undefined,
                    product || undefined
                ),
                listPrice: selectedProductData?.listPrice || 0 ? listPrice : null
            };
        }
        return null;
    }, [selectedProductData, currencyCode, salesChannel.metadata]);

    useEffect(() => {
        loadProductData();
    }, [product]);

    return (
        <div className="flex -mx-3 w-full items-center">
            <div className="px-3">
                <Button
                    padding="py-2 px-6"
                    onClick={handleAddToCartClick}
                    disabled={adding}
                    loader={adding}
                >
                    Sign Up
                </Button>
            </div>
            <div className="px-3">
                <span className="text-3xl h-[35px] flex items-center font-bold text-center md:text-left">
                    {selectedProductData == null ? (
                        <Spinner className="px-5" height="35px" />
                    ) : (
                        <>
                            {pricing?.listPrice && (
                                <span className="text-gray-500 font-normal line-through mr-2">
                                    {pricing?.listPrice}
                                </span>
                            )}
                            {pricing?.price}
                        </>
                    )}
                </span>
            </div>
        </div>
    );
}
